//Implementation is based on this stack overflow article: https://stackoverflow.com/questions/27638402/strip-exif-data-from-image
export default class ExifDataRemover{
  originalFile: File
  modifiedFile: File
  fileReader: any

  constructor(file) {
    this.originalFile = file
  }

  processFile() {
    return new Promise((resolve, reject) => {
      this.fileReader = new FileReader();
      this.fileReader.onload = ()=> resolve(this.process());
      this.fileReader.readAsArrayBuffer(this.originalFile);
    })
  }

  get file() : File{
    //A modified file doesn't always get created. Unsure why it may only hit the conditional block on line 47
    // when an image has exif data and otherwise skips it
    return this.modifiedFile || this.originalFile
  }

  process(){
    const dv = new DataView(this.fileReader.result);
    let offset = 0, recess = 0;
    const pieces = [];
    let i = 0;
    if (dv.getUint16(offset) === 0xffd8){
      offset += 2;
      let app1 = dv.getUint16(offset);
      offset += 2;
      while (offset < dv.byteLength){
        if (app1 === 0xffe1){

          pieces[i] = {recess:recess,offset:offset-2};
          recess = offset + dv.getUint16(offset);
          i++;
        }
        else if (app1 === 0xffda){
          break;
        }
        offset += dv.getUint16(offset);
        app1 = dv.getUint16(offset);
        offset += 2;
      }
      if (pieces.length > 0){
        let newPieces = [];
        pieces.forEach(function(v){
          newPieces.push(this.fileReader.result.slice(v.recess, v.offset));
        }, this);
        newPieces.push(this.fileReader.result.slice(recess));
        let br = new Blob(newPieces, {type: 'image/jpeg'});
        this.modifiedFile = new File([br], "img.jpg",{type:"image/jpeg", lastModified:new Date().getTime()});
      }
    }
  }

}